import { render } from "./ClusterDeleteForm.vue?vue&type=template&id=250db34b"
import script from "./ClusterDeleteForm.vue?vue&type=script&lang=js"
export * from "./ClusterDeleteForm.vue?vue&type=script&lang=js"
script.render = render

export default script